import type { DomainMapper } from '../types';

import at from './at';
import de from './de';
import dk from './dk';
import fi from './fi';
import fr from './fr';
import gb from './gb';
import global from './global';
import no from './no';
import se from './se';
import us from './us';
import corporateEn from './corporate-en';
import corporateSe from './corporate-se';

const previewDomains: DomainMapper[] = [
  gb,
  de,
  at,
  fr,
  us,
  se,
  no,
  fi,
  dk,
  global,
  corporateEn,
  corporateSe,
];

export default previewDomains;
